import { assertUnreachable } from 'src/lib/assertUnreachable';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

import { LaunchSequenceStepStatus } from './launchStepProgressBar/LaunchSequenceStatusIcon';

export const titleForStep = (
  step: GraphQLTypes.LaunchSequenceStepFragment,
  launch: GraphQLTypes.LaunchSequenceLaunchFragment,
) => {
  let title: string;
  switch (step.__typename) {
    case 'LaunchSequenceInitiatedStep':
      title = 'Launch initiated';
      break;
    case 'LaunchSequenceBuildStep':
      title =
        launch.build?.result?.__typename === 'BuildFailure'
          ? 'Build failed'
          : step.completedAt
            ? 'Build completed'
            : 'Building';
      break;
    case 'LaunchSequencePublishStep':
      title = step.completedAt ? 'Schema published' : 'Publishing schema';
      break;
    case 'LaunchSequenceSupersededStep':
      title = 'Superseded';
      break;
    case 'LaunchSequenceCompletedStep':
      title = 'Launch completed';
      break;
    default:
      assertUnreachable(step);
  }
  return title;
};

export const launchStatusForStep = (
  step: GraphQLTypes.LaunchSequenceStepFragment,
  launch: GraphQLTypes.LaunchSequenceLaunchFragment,
) => {
  // show an error for failed builds
  if (
    step.__typename === 'LaunchSequenceBuildStep' &&
    launch.build?.result?.__typename === 'BuildFailure'
  ) {
    return LaunchSequenceStepStatus.FAILED;
  }

  if (step.__typename === 'LaunchSequenceSupersededStep') {
    return LaunchSequenceStepStatus.SUPERSEDED;
  }

  // show a completed icon for completed steps (or the initiated step)
  if (step.__typename === 'LaunchSequenceInitiatedStep' || step.completedAt) {
    return LaunchSequenceStepStatus.COMPLETED;
  }

  // if the launch is still in progress, show pulse animations for
  // steps not yet completed
  if (
    launch.status === GraphQLTypes.LaunchStatus.LAUNCH_INITIATED &&
    step.__typename !== 'LaunchSequenceCompletedStep' &&
    step.startedAt &&
    !step.completedAt
  ) {
    return LaunchSequenceStepStatus.INTIATED;
  }

  // otherwise, return the step icon for "not yet started"
  return LaunchSequenceStepStatus.QUEUED;
};
